export default __webpack_public_path__ + "799038dfe0a5fdeff84888fac2201982.jpg";